import { DataTable } from "@fdoh/health-react";
import { InspectionHistoryData, inspectionHistoryColumns } from "./InspectionHistory.types";

interface InspectionHistoryProps {
    appData: InspectionHistoryData[];
    apNumber: string;
}

export const InspectionHistoryPage = ({ appData, apNumber }: InspectionHistoryProps) => {

    return (
        <div className="mt-4">
            <DataTable
                name="inspectionHistory"
                columns={inspectionHistoryColumns}
                data={appData}
                title="Inspection History"
                globalFilter
                striped
                vcenter
            />
        </div>
    );
};


